Auth = require 'app/scripts/db/auth'
ApiPromise = require 'app/scripts/network/api-promise'
ApiError = require 'app/scripts/network/api-error'
compress = require('emoji-mart/dist-es/utils/data').compress
NimbleEmojiIndex = require('emoji-mart/dist-es/utils/emoji-index/nimble-emoji-index').default
_ = require 'underscore'
Promise = require 'bluebird'

class EmojiProvider
  categories: [
    ['Smileys & People', 'people']
    ['Animals & Nature', 'nature']
    ['Food & Drink', 'foods']
    ['Activities', 'activity']
    ['Travel & Places', 'places']
    ['Objects', 'objects']
    ['Symbols', 'symbols']
    ['Flags', 'flags']
  ]
  apiRoot: '/1/emoji'
  apiParams: ->
    spritesheets: true
    locale: Auth.myLocale()
  data: null
  emojiIndex: null
  spriteSheets: null

  _fetchEmoji: =>
    if @fetchPromise?
      return @fetchPromise

    @fetchPromise = ApiPromise
      url: @apiRoot
      data: @apiParams()
    .then @_processEmoji
    .catch (e) -> console.error e

  # Lower case full string, replace -/_ with space
  # then upper case first char of string
  _formatName: (name) ->
    # This is a list of words that should not be capitalized for title case.
    nonTitlecasedWords = [
      'and', 'or', 'nor', 'a', 'an', 'the', 'so', 'but', 'to', 'of', 'at', 'by'
      'from', 'into', 'on', 'onto', 'off', 'out', 'in', 'over', 'with', 'for'
    ]

    name
      .toLowerCase()
      .replace(/[\-_]/g, ' ')
      .split(' ')
      .map (word) ->
        if word in nonTitlecasedWords
          word
        else
          word.replace /\b\w/g, (l) -> l.toUpperCase()
      .join(' ')


  # Adapted from Emoji-Marts build process
  # emoji-mart/scripts/build.js
  _processEmoji: (emojiSource) =>
    data =
      compressed: true,
      categories: [],
      emojis: {},
      aliases: {}
      spriteSheets: {}

    categoriesIndex = {}
    @categories.forEach ([name, id], i) =>
      data.categories[i] =
        id: id,
        name: name,
        emojis: []
      categoriesIndex[name] = i


    emojiSource.trello.forEach (datum) =>
      keywords = []
      emoji =
        name: @_formatName(datum.name ? datum.shortName)
        unified: datum.unified
        sheet_x: datum.sheetX
        sheet_y: datum.sheetY
        text: datum.text ? ''
        emoticons: datum.texts ? []
        short_name: datum.shortName
        short_names: datum.shortNames
        keywords: datum.keywords

      if datum.skinVariations?
        emoji.skin_variations = _.mapObject datum.skinVariations, (variation) ->
          unified: variation.unified,
          native: variation.native
          sheet_x: variation.sheetX,
          sheet_y: variation.sheetY

      if datum.category != 'Skin Tones'
        categoryIndex = categoriesIndex[datum.category]
        data.categories[categoryIndex].emojis.push(emoji.short_name)
        data.emojis[emoji.short_name] = emoji

      emoji.short_names.forEach (short_name, i) ->
        if (i == 0) then return
        data.aliases[short_name] = emoji.short_name

      compress(emoji)

    flags = data.categories[categoriesIndex['Flags']]
    flags.emojis = flags.emojis
      .filter((flag) ->
        # Until browsers support Flag UN
        if (flag == 'flag-un') then return
        return true
      )
      .sort()

    @data = data
    @emojiIndex = new NimbleEmojiIndex(data)
    @spriteSheets = emojiSource.spriteSheets

    data

  getData: ->
    @_fetchEmoji()

  # Like `getData`, but will not fetch emoji, will just return `null` if no
  # data is available. Useful for ensuring the initial render gets cached emoji
  # if they are already available
  getDataSync: -> @data

  getIndex: ->
    @_fetchEmoji()
      .then =>
        return @emojiIndex

  getSpritesheets: ->
    @_fetchEmoji()
      .then =>
        return @spriteSheets

  getSpritesheetsUrl: (set, sheetSize) =>
    @spriteSheets[set]?[sheetSize]?.url


module.exports = new EmojiProvider()
